import { FeedbackPage } from 'Frontend/scripts/models/foodHabits.model'
import { FunctionComponent } from 'react'

type Props = { feedbackPage: FeedbackPage }

const FeedbackPageComponent: FunctionComponent<Props> = ({ feedbackPage }) => (
  <div>
    {feedbackPage.heading && <h1 className="foodhabits-h1">{feedbackPage.heading}</h1>}
    <p className="text-block">{feedbackPage.body}</p>
  </div>
)

export default FeedbackPageComponent
